export const font = {
  res: {
    sm: `clamp(9px,.7vw,11px)`,
    base: `clamp(10px,.8vw,14px)`
  }
};
